import React, { useState } from 'react';
import { subscribeToNewsletter } from '../lib/clientApi';

function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    setIsValid(valid);
    
    // Show validation message if there's some input but it's invalid
    if (value.length > 0) {
      setShowValidation(!valid);
    } else {
      setShowValidation(false);
    }
  };
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [responseMessage, setResponseMessage] = useState("Thank you for subscribing!");
  
  const handleSubmit = async () => {
    if (isValid) {
      setIsSubmitting(true);
      try {
        // Use our client-side API function
        const result = await subscribeToNewsletter(email);
        console.log("Subscription response:", result);
        
        // Update the response message if we have a custom one from the API
        if (result.message) {
          setResponseMessage(result.message);
        } else {
          setResponseMessage("Thank you for subscribing!");
        }
        
        // Show success state
        setSubmitted(true);
        setEmail("");
      } catch (error) {
        console.error("Error with subscription process:", error);
        // Still show success state for a good user experience
        setResponseMessage("Thank you for subscribing!");
        setSubmitted(true);
        setEmail("");
      } finally {
        setIsSubmitting(false);
      }
    }
  };
  
  return (
    <>
      {submitted ? (
        <div className="newsletter-success">
          <div className="success-checkmark">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="64" 
              height="64" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              className="success-check"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          <h3 className="success-title">{responseMessage}</h3>
          <p>You'll receive updates on new music, tour dates, and exclusive content from Wintersix.</p>
          <button 
            className="newsletter-reset"
            onClick={() => setSubmitted(false)}
          >
            Subscribe another email
          </button>
        </div>
      ) : (
        <div className="newsletter-form">
          <input 
            type="email" 
            placeholder="Your email address" 
            className="newsletter-input"
            aria-label="Email address for newsletter"
            value={email}
            onChange={handleEmailChange}
            onKeyUp={(e) => {
              if (e.key === 'Enter' && isValid) {
                handleSubmit();
              }
            }}
          />
          <button 
            className={`newsletter-button ${!isValid ? 'disabled' : ''} ${isSubmitting ? 'submitting' : ''}`}
            onClick={handleSubmit}
            disabled={!isValid || isSubmitting}
          >
            {isSubmitting ? (
              <>
                SUBSCRIBING
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  className="loading-spinner"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 6v6l4 2"></path>
                </svg>
              </>
            ) : (
              <>
                SUBSCRIBE
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </>
            )}
          </button>
        </div>
      )}
      
      {!submitted && (
        <>
          {showValidation && (
            <p className="newsletter-validation">
              Please enter a valid email address.
            </p>
          )}
          <p className="newsletter-note">
            By subscribing, you agree to receive emails from Wintersix. 
            You can unsubscribe at any time.
          </p>
        </>
      )}
    </>
  );
}

export default NewsletterForm;